import api from './api';

/**
 * Service for managing notification settings
 */
class NotificationSettingsService {
  /**
   * Get notification settings for a specific type
   * @param {string} settingType - Type of notification (e.g., 'booking_confirmation')
   * @returns {Promise<Object>}
   */
  async getSettings(settingType) {
    return api.get(`/notification-settings/${settingType}`);
  }

  /**
   * Update notification settings
   * @param {string} settingType - Type of notification
   * @param {Object} settings - Settings to update
   * @returns {Promise<Object>}
   */
  async updateSettings(settingType, settings) {
    return api.put(`/notification-settings/${settingType}`, settings);
  }

  /**
   * Add a recipient to notification settings
   * @param {string} settingType - Type of notification
   * @param {Object} recipient - Recipient data
   * @returns {Promise<Object>}
   */
  async addRecipient(settingType, recipient) {
    return api.post(`/notification-settings/${settingType}/recipients`, recipient);
  }

  /**
   * Remove a recipient from notification settings
   * @param {string} settingType - Type of notification
   * @param {string} recipientId - ID of recipient to remove
   * @returns {Promise<Object>}
   */
  async removeRecipient(settingType, recipientId) {
    return api.delete(`/notification-settings/${settingType}/recipients/${recipientId}`);
  }

  /**
   * Update a specific recipient
   * @param {string} settingType - Type of notification
   * @param {string} recipientId - ID of recipient to update
   * @param {Object} recipientData - Updated recipient data
   * @returns {Promise<Object>}
   */
  async updateRecipient(settingType, recipientId, recipientData) {
    return api.put(`/notification-settings/${settingType}/recipients/${recipientId}`, recipientData);
  }

  // ============================================
  // Self-Service Notification Preferences
  // ============================================

  /**
   * Get current user's notification preferences
   * @returns {Promise<Object>}
   */
  async getMyPreferences() {
    return api.get('/auth/notification-preferences');
  }

  /**
   * Update current user's notification preferences
   * @param {Object} preferences - Preferences to update
   * @returns {Promise<Object>}
   */
  async updateMyPreferences(preferences) {
    return api.put('/auth/notification-preferences', preferences);
  }
}

export default new NotificationSettingsService();
